import { Capacitor } from '@capacitor/core'
import { FlightMapNative, type FlightMapFrame } from './flight-map'
import { getKeyboardHeight, subscribeKeyboard } from '@/lib/keyboard'

// The PassthroughWebView only forwards touches to the native map when they fall
// outside the registered interactive rect. Screens host one "base" rect (the
// resizable drawer at the bottom), but modal drawers can sit on top of it and
// extend beyond that rect — taps in the modal would otherwise pass through to
// the map. This module keeps a stack: while any modal is open we register a
// fullscreen rect, otherwise we re-apply the screen's base rect.

let baseRect: FlightMapFrame | null = null
let modalCount = 0

function apply() {
  // The native map (and its PassthroughWebView) only exists on iOS.
  if (Capacitor.getPlatform() !== 'ios') return
  if (modalCount > 0) {
    FlightMapNative.setOverlayRect({
      x: 0,
      y: 0,
      width: window.innerWidth,
      height: window.innerHeight,
    }).catch(() => {})
    return
  }
  if (baseRect) {
    // Bottom sheets lift themselves above the keyboard (Keyboard.resize is
    // "none"), so extend the interactive rect upward by the same amount —
    // otherwise taps on the lifted top strip would fall through to the map.
    const kb = getKeyboardHeight()
    FlightMapNative.setOverlayRect(
      kb > 0
        ? { ...baseRect, y: baseRect.y - kb, height: baseRect.height + kb }
        : baseRect,
    ).catch(() => {})
  } else {
    FlightMapNative.clearOverlayRect().catch(() => {})
  }
}

subscribeKeyboard(apply)

export function setBaseOverlayRect(rect: FlightMapFrame) {
  baseRect = rect
  apply()
}

export function clearBaseOverlayRect() {
  baseRect = null
  apply()
}

export function pushFullscreenOverlay() {
  modalCount++
  apply()
}

export function popFullscreenOverlay() {
  modalCount = Math.max(0, modalCount - 1)
  apply()
}
